<template>
  <div class="appBody bg-grey-light">
    <div v-if="sessionSignInObj && sessionSignInObj.id">
      <van-row type="flex" class="signin-content flex-column align-items-center">
        <van-col class="ava">
          <van-image
            src="/static/img/pro/signin_finished.png"
          />
        </van-col>
        <van-col class="name mt-28">{{justSignIn ? '签到成功' : '您已签到'}}</van-col>
        <van-col>
          <van-row type="flex" class="flex-column align-items-center mt-2">
            <van-col class="color-77 font-14 line-16"
                     v-if="sessionSignInObj.userSession&&sessionSignInObj.userSession.createdTime">
              签到时间：{{sessionSignInObj.userSession.createdTime |dateFormat('YYYY年MM月DD日 HH:mm')}}
            </van-col>
            <van-col class="color-88 font-14 line-16 mt-3 pt-3">
              感谢您的参与
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import NoData from "@/components/noData";
  import {mapState} from "vuex";
  import {Loading} from 'vant';
  import Vue from 'vue';
  import {Icon} from 'vant';
  import {SwipeCell} from 'vant';
  import {Button} from 'vant';
  import {Col, Row} from 'vant';
  import {Card} from 'vant';
  import {Progress} from 'vant';
  import Cookies from "js-cookie";
  import {Image as VanImage} from 'vant';

  Vue.use(VanImage);
  Vue.use(Loading);
  Vue.use(Card);
  Vue.use(Progress);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Button);
  Vue.use(SwipeCell);
  Vue.use(Icon);

  export default {
    name: "signinFinished",
    data() {
      return {
        justSignIn: true,
        userInfo: {},
      }
    },
    props: ['sessionSignInObj'],
    components: {
      littleFooter,
      LittleHeader,
      NoData
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl
      })
    },
    mounted() {
      if (Cookies.get('anqiu_education_token') && Cookies.get('u_info')) {
        this.userInfo = JSON.parse(Cookies.get('u_info'));
      } else {
        this.userInfo = {};
      }
    },
    methods: {
      signInFinish() {
        //签到方法
      }
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .mt-28 {
    margin-top: pxTorem(28px);
  }

  .name {
    margin-top: pxTorem(20px);
    font-size: pxTorem(16px);
    line-height: pxTorem(18px);
    color: #2474ff;
  }

  .ava {
    margin-top: pxTorem(120px);
    width: pxTorem(172px);
    height: pxTorem(96px);
  }

  .signin-location {
    left: pxTorem(16px);
    bottom: pxTorem(20px);
  }
</style>
